import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";

export default function FormalitiesRequestStatusDropdown({
  selected = "all",
  onChange,
  disabled = false,
  readOnly = false,
  isFront = true,
  size = "lg",
}) {
  const config = useSelector((state) => state.config);
  const [open, setOpen] = useState(false);
  const [dropUp, setDropUp] = useState(false);
  const containerRef = useRef(null);
  const menuRef = useRef(null);

  const statuses = { ...config.formalities.requests.status };

  // Détecte si le menu doit s'ouvrir vers le haut
  useEffect(() => {
    if (!open || !containerRef.current || !menuRef.current) return;

    const buttonRect = containerRef.current.getBoundingClientRect();
    const menuHeight = menuRef.current.offsetHeight;
    const spaceBelow = window.innerHeight - buttonRect.bottom;
    const spaceAbove = buttonRect.top;

    setDropUp(spaceBelow < menuHeight && spaceAbove > spaceBelow);
  }, [open]);

  // Fermeture au clic extérieur
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <div ref={containerRef} style={{ position: "relative", display: "inline-block" }}>
      <button
        className={`btn btn-${size} btn-outline-secondary dropdown-toggle d-flex align-items-center gap-2`}
        type="button"
        disabled={disabled || readOnly}
        onClick={() => setOpen((o) => !o)}
      >
        {statuses[selected]?.label || "Par statut"}
      </button>
      {open && (
        <ul
          ref={menuRef}
          className="dropdown-menu dropdown-menu-end show"
          style={{
            display: "block",
            position: "absolute",
            right: 0,
            left: 'unset',
            zIndex: 1050,
            // Ouvre vers le haut ou le bas selon la place disponible
            ...(dropUp
              ? { bottom: "100%", top: "auto", marginBottom: "2px" }
              : { top: "100%", bottom: "auto", marginTop: "2px" }),
          }}
        >
          {Object.entries(statuses).map(([key, info]) => (
            info.active == true &&
            <li key={key}>
              <button
                className="dropdown-item d-flex align-items-center gap-2"
                onClick={() => {
                  onChange(key);
                  setOpen(false);
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor: info.color,
                    flexShrink: 0,
                  }}
                />
                {info.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}